<script lang="ts">
  import { signature } from 'svelte-signature-pad'
  import { escapeAttribute } from '../lib/dom';

  let {
    name = null,
    value = $bindable(),
    required = false,
    showClear = true
  } = $props()

  let layers: { path: string; width: number; height: number }[] = $state([])

  let width: number = $state()
  let height: number = $state()
  let preview: string = $state()

  const ondraw = (path: string) => (preview = path)
  const oncomplete = (path: string) => {
    if(!path) return;
    preview = ''
    layers = [...layers, { width, height, path }]
    const w = Math.max(...layers.map((l)=>l.width))
    const h = Math.max(...layers.map((l)=>l.height))
    let paths = layers.map(layer=>`<path d="${escapeAttribute(layer.path)}" />`).join("")
    value = `<svg xmlns="http://www.w3.org/2000/svg" viewbox="0 0 ${w} ${h}" width="${w}" height="${h}">${paths}</svg>`
  }

  export function clear() {
    layers = []
    value = ""
  }

  // This is an appaling hack to prevent scrolling on touch devices
  let container: HTMLDivElement = $state()
  let modalBox
  const ontouchstart = (e:TouchEvent) => {
    if(container.contains(e.target as Node)) {
      modalBox = container.closest(".modal-box")
      modalBox.style.overflow = "hidden"
    }
  }
  const ontouchend = () => {
    if(modalBox) modalBox.style.overflow = ""
  }

  let requiredInput: HTMLInputElement = $state()
  const minPathChars = 500 // Cutoff determined by examining example signatures; corresponds roughly to min SVG length of 650
  $effect(()=>{
    // Extract just the path data
    const pathDataMatch = value?.matchAll(/<path[^>]*\s+d="([^"]+)"/g) || []
    const pathData = [...pathDataMatch].map(m => m[1]).join("")
    const present = pathData.length >= minPathChars
    requiredInput?.setCustomValidity(present ? "" : "Required")
  })
</script>
<svelte:window {ontouchstart} {ontouchend} />
<div bind:this={container} class="relative w-full bg-Blue-100 border border-dashed border-Blue-300 rounded-lg">
  {#if required}<input type="checkbox" {name} bind:this={requiredInput} class="sr-only">{/if}
  {#if name}<input {name} {value} type="hidden">{/if}
  <canvas width="200" height="100" class="w-full h-auto invisible"></canvas>
  <div class="absolute left-[4%] right-[4%] bottom-[35%] border-b border-Neutral-400 pointer-events-none pb-1.5 text-xl leading-[1.3] text-Neutral-500">
    X
  </div>
  <div
    class="w-full h-full absolute left-0 top-0 touch-none"
    use:signature={{ ondraw, oncomplete }}
    bind:clientWidth={width}
    bind:clientHeight={height}
  >
    {#each layers as layer}
      <svg class="absolute w-full h-full fill-black pointer-events-none" viewBox="0 0 {layer.width} {layer.height}">
        <path d={layer.path} />
      </svg>
    {/each}

    {#if preview}
      <svg class="absolute w-full h-full fill-blue-700 pointer-events-none" viewBox="0 0 {width} {height}">
        <path d={preview} />
      </svg>
    {/if}
  </div>
  {#if showClear}<button type="button" class="absolute top-2 right-2 btn btn-xs font-normal bg-white" onclick={clear}>Clear</button>{/if}
</div>
